<script lang="ts">
  import { UnsignedMattersState, type CloseActionType } from "./LeadUnsigned/UnsignedMattersState.svelte";
  import LeadUnsignedDialog from "./LeadUnsignedDialog.svelte";
  import OfferStep from "./LeadUnsigned/OfferStep.svelte";
  import SignatureStep from "./LeadUnsigned/SignatureStep.svelte";
  import ConfirmRejectionStep from "./LeadUnsigned/ConfirmRejectionStep.svelte";
  import SuccessStep from "./LeadUnsigned/SuccessStep.svelte";
  import Info from "~icons/ph/info";
  import toggleState from "../lib/toggleState.svelte";

  let {
    manager,
    openOnMount,
    afterClose = (action: CloseActionType) => {},
  }: {
    manager: UnsignedMattersState,
    openOnMount: boolean,
    afterClose?: (CloseActionType) => void,
  } = $props();

  let showHelp = toggleState(false);
</script>

<LeadUnsignedDialog {manager} {openOnMount} {afterClose}>
  <div class={showHelp.value ? "hidden" : "contents"}>
    {#if manager.currentStep == manager.offerStep}
      <OfferStep {manager}>
        {#snippet introduction(plural)}
          {#if plural}
            Our records show you may have Diesel Particulate Filter (DPF) claims each worth <span class="whitespace-nowrap font-bold">£1,000s</span> regarding your vehicles below.
          {:else}
            Our records show you may have a Diesel Particulate Filter (DPF) claim worth <span class="whitespace-nowrap font-bold">£1,000s</span> regarding your vehicle below.
          {/if}
          <a href="#what_is_dpf" onclick={showHelp.toggle} class="text-primary underline whitespace-nowrap">What is a DPF claim?</a>
        {/snippet}
        {#snippet notice()}
          <div class="mt-5 -mx-1">
            <p class="alert alert-info p-3 gap-3 text-sm text-left">
              <Info class="w-6 h-6 hidden sm:block" />
              You may be eligible for compensation even if you have not experienced issues due to a faulty DPF.
            </p>
          </div>
        {/snippet}
      </OfferStep>
    {:else if manager.currentStep == manager.signatureStep}
      <SignatureStep {manager}>
        {#snippet header(plural)}
          We believe you may have {plural ? "claims" : "a claim"} for {plural ? "these vehicles" : "this vehicle"} <span class="whitespace-nowrap">worth £1,000s!</span>
        {/snippet}
      </SignatureStep>
    {:else if manager.currentStep == manager.rejectionStep}
      <ConfirmRejectionStep {manager} toggleHelp={showHelp.toggle} />
    {:else if manager.currentStep == manager.successStep}
      <SuccessStep {manager} />
    {/if}
  </div>

  {#if showHelp.value}
    <h2 class="ui-title mb-3">Jaguar Land Rover DPF Claims</h2>
    <p class="text-base mb-3">
      We are pursuing legal action against Jaguar Land Rover over allegations that certain vehicles were fitted with defective Diesel Particulate Filter (DPF) systems. These defects may cause performance issues, increased maintenance costs, and non-compliance with emissions standards.
    </p>
    <p class="text-base mb-3">
      We believe your vehicle qualifies, and that you could be entitled to significant compensation as part of this group claim.
    </p>
    <div class="floating-footer">
      <button class="btn btn-primary" onclick={showHelp.toggle}>Back</button>
    </div>
  {/if}
</LeadUnsignedDialog>
